import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import DSButton from '@elliemae/ds-basic/Button';
import DSCheckbox from '@elliemae/ds-basic/form/Checkbox';
import DSComboBox from '@elliemae/ds-basic/form/ComboBox';
import DSRadio from '@elliemae/ds-basic/form/Radio';
import DSTextBox from '@elliemae/ds-basic/form/TextBox';
import DSToggle from '@elliemae/ds-basic/form/Toggle';
import DSDropdownMenu from '@elliemae/ds-dropdownmenu';
import { r as renderers } from '../../index-4a6329dc.js';
import '../../components/renderers/defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import '../../blockNames.js';
import '../../components/renderers/renderRowsLoader.js';
import '../../components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';

var components = {
  DSButton: DSButton,
  DSCheckbox: DSCheckbox,
  DSComboBox: DSComboBox,
  DSRadio: DSRadio,
  DSTextBox: DSTextBox,
  DSToggle: DSToggle,
  DSDropdownMenu: DSDropdownMenu
};

var getRendererComponent = function getRendererComponent(_ref2, _ref, _ref3) {
  var props = _ref2.props;
  var rowData = _ref3.rowData;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'DSTextBox' : _ref$type,
      handlers = _ref.handlers,
      rest = _objectWithoutProperties(_ref, ["type", "handlers"]);

  var Component = components[type] || renderers[type];
  var customHandlers = props.customHandlers,
      rowKey = props.rowKey;
  var mappedHandlers = {};
  Object.keys(handlers).forEach(function (key) {
    mappedHandlers[handlers[key]] = function () {
      return typeof customHandlers[key] === 'function' ? customHandlers[key](rowData, rowData[rowKey]) : null;
    };
  });
  return /*#__PURE__*/React.createElement(Component, _extends({}, rowData, mappedHandlers, rest));
};

export default getRendererComponent;
//# sourceMappingURL=getRendererComponent.js.map
